var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"attach-icon"},[_c('div',{staticClass:"filter-group-header"},[_c('div',[_vm._v("FILTER")]),_c('span',{staticClass:"reset-filters",on:{"click":_vm.resetAllFilters}},[_vm._v("Clear All Filters")])])])}
var staticRenderFns = []

export { render, staticRenderFns }